<template>
  <div class="admin-datatable">
    <v-card>
    <v-toolbar dark flat color="primary">
      <v-toolbar-title>Zawody</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn v-if="!showAdd" color="accent" @click="showAdd = true" dark>dodaj zawody</v-btn>
      <v-btn v-if="showAdd" flat small @click="showAdd = false">ukryj</v-btn>
    </v-toolbar>
    </v-card>
    <v-slide-y-transition>
    <v-card class="mt-2" v-if="showAdd">
      <race-form @success="showAdd = false; refresh()"></race-form>
    </v-card>
    </v-slide-y-transition>
    <v-card class="mt-2 pb-1">
      <v-card-title>
        <v-form class="flex">
          <v-layout row wrap justify-start>
            <v-flex xs12 sm6 md4 xl3 class="pa-1">
              <v-text-field v-model="context.searchQuery"
                clearable
                label="Szukaj (nazwa lub miasto)"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md4 xl3 class="pa-1">
              <v-select
                v-model="context.priority"
                :items="[{text: 'A', value: 'A'}, {text: 'B', value: 'B'}, {text: 'C', value: 'C'}]"
                label="Priorytet"
                clearable
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6 md4 xl3 class="pa-1">
              <v-select
                v-model="context.raceType"
                :items="allRaceTypesStringsOptions"
                label="Rodzaj"
                clearable
              ></v-select>
            </v-flex>
              <v-flex xs12 sm6 md4 xl3 class="pa-1">
                <v-select
                  v-model="context.distance"
                  :items="allRaceDistanceStringsOptions"
                  label="Dystans (tylko uliczne i bieżnia)"
                  clearable
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 md4 xl3 class="pa-1">
                <v-menu
                  ref="menu1"
                  :close-on-content-click="false"
                  v-model="menu1"
                  :nudge-right="40"
                  :return-value.sync="context.start"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="context.start"
                    label="Data od"
                    prepend-icon="event"
                    readonly
                    clearable
                  ></v-text-field>
                  <v-date-picker v-model="context.start" @input="$refs.menu1.save(context.start)" no-title locale="pl"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm6 md4 xl3 class="pa-1">
                <v-menu
                  ref="menu2"
                  :close-on-content-click="false"
                  v-model="menu2"
                  :nudge-right="40"
                  :return-value.sync="context.end"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="context.end"
                    label="Data do"
                    prepend-icon="event"
                    readonly
                    clearable
                  ></v-text-field>
                  <v-date-picker v-model="context.end" @input="$refs.menu2.save(context.end)" no-title locale="pl"></v-date-picker>
                </v-menu>
              </v-flex>
          </v-layout>
        </v-form>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="races"
        :pagination.sync="context"
        :rows-per-page-items="perPageOptions"
        :total-items="rowsTotal"
        :loading="loading"
      >
        <template slot="items" slot-scope="props">
          <tr>
          <td>
            {{ props.item.race_date | formatDate('LL') }}
          </td>
          <td>{{ props.item.name}}</td>
          <td>{{ props.item.city}}</td>
          <td>{{ props.item.race_type_name}}</td>
          <td v-if="['other', 'ultra'].indexOf(props.item.distance_string) > -1">{{ props.item.distance_km}} km</td>
          <td v-if="['other', 'ultra'].indexOf(props.item.distance_string) === -1">{{ props.item.distance_string_name}}</td>
          <td v-if="props.item.race_type == 'street'">{{ formatterBool(props.item.certified)}}</td>
          <td v-else>--</td>
          <td>{{ props.item.priority}}</td>
          <td>{{ props.item.time}}</td>
          <td class="actions">
            <rp-icon
              type="edit"
              tooltip="edytuj"
              class="mr-2"
              @click="expand(props, 'edit')"
            />
            <rp-icon
              type="timer"
              tooltip="rezultat"
              class="mr-2"
              @click="expand(props, 'result')"
            />
            <rp-icon
              type="delete"
              tooltip="usuń"
              @click="deleteItem(props.item)"
            />
          </td>
          </tr>
        </template>
        <template slot="expand" slot-scope="props">
            <race-form v-if="type == 'edit'" :race-data="props.item" @success="props.expanded = false; refresh()"></race-form>
            <race-results-form v-if="type == 'result'" :race-data="props.item" @success="props.expanded = false; refresh()"></race-results-form>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import {fetchRaces, deleteRace} from '../plan/api'
import {ListMixin} from '@/utils/ListMixin'
import { mapState, mapGetters } from 'vuex'
import {boolFormatter} from '@/utils/formatters'
import _ from 'lodash'
import iziToast from 'izitoast'

import RaceForm from './RaceForm'
import RaceResultsForm from './RaceResultsForm'

export default {
  name: 'races',
  components: {RaceForm, RaceResultsForm},
  mixins: [ListMixin],
  data () {
    return {
      context: {
        rowsPerPage: 10,
        sortBy: 'race_date',
        descending: true},
      type: null,
      showAdd: false,
      loading: true,
      menu1: false,
      menu2: false,
      races: [],
      headers: [
        {
          value: 'race_date',
          text: 'data',
          sortable: true
        },
        {
          value: 'name',
          text: 'nazwa',
          sortable: true
        },
        {
          value: 'city',
          text: 'miasto',
          sortable: true
        },
        {
          value: 'race_type',
          text: 'rodzaj',
          sortable: true
        },
        {
          value: 'distance',
          text: 'dystans',
          sortable: true
        },
        {
          value: 'certified',
          text: 'atest',
          sortable: true
        },
        {
          value: 'priority',
          text: 'priorytet',
          sortable: true
        },
        {
          value: 'time',
          text: 'czas',
          sortable: true
        },
        {
          value: 'actions',
          text: 'akcje',
          align: 'center',
          sortable: false,
          width: '180px'
        }
      ]
    }
  },
  computed: {
    ...mapState(['runner']),
    ...mapGetters(['allRaceDistanceStringsOptions', 'allRaceTypesStringsOptions'])
  },
  watch: {
    context: {
      handler (a, b) {
        if (a.page === b.page && a.page !== 1) {
          this.context.page = 1
        } else {
          this.getRaces()
        }
      },
      deep: true
    },
    '$route': 'getRaces'
  },
  methods: {
    formatterBool (data) {
      return boolFormatter(data)
    },
    getRaces () {
      this.loading = true
      let params = this.prepareParams()
      if (this.context.priority !== null) {
        params['priority'] = this.context.priority
      }
      if (this.context.raceType !== null) {
        params['race_type'] = this.context.raceType
      }
      if (this.context.raceType !== null) {
        params['race_type'] = this.context.raceType
      }
      if (this.context.distance) {
        params['distance_string'] = this.context.distance
      }
      if (this.context.end) {
        params['race_date__lte'] = this.context.end
      }
      if (this.context.start) {
        params['race_date__gte'] = this.context.start
      }
      let promise = fetchRaces(this.runner, params)
      return promise.then(this.enhanceListData).then((data) => {
        this.loading = false
        this.races = data
        return data
      })
    },
    expand (props, type) {
      if (this.type === type) {
        props.expanded = !props.expanded
      } else {
        this.type = type
        props.expanded = true
      }
    },
    deleteItem (item) {
      this.$root.$confirm('Usuń zawody', 'Czy na pewno usunąć zawody?', {confirmText: 'Usuń', color: 'error'}).then((willDelete) => {
        if (willDelete) {
          let promise = deleteRace(this.runner, item)
          return promise.then(() => {
            this.refresh()
            iziToast.show({
              message: 'Zawody zostały usunięte',
              color: 'green'
            })
          }).catch(() => {
            iziToast.show({
              message: 'Nie udało się usunąć zawodów.',
              color: 'red'
            })
          })
        }
      })
    },
    refresh: _.debounce(function () {
      this.getRaces()
    }, 400)
  }
}
</script>



// WEBPACK FOOTER //
// src/races/Races.vue